<template>
<div class="" >

 <team-member v-for="(member, index) in teamMembers" :key="member.user_id" :member="member" :memberIndex="index" :amICaptain="amICaptain" @leave="$emit('leave')" :team="team"
 @updateMembers="capChange"
 @memberDeleted="getMembers"
  />
 <team-member v-if="newTeam" :captainOnly="true" :member="cur_user" />

    <div v-if="!newTeam && team.players_count < team.max_players_count" class="flex flex-row items-center cursor-pointer h-8 mt-10">
                      <div  @click.stop.prevent="addMember"
                          class="hover-up outline-none rounded-full flex flex-row justify-center items-center h-8 w-8 bg-brand-light cursor-pointer">
                          <font-awesome-icon class="text-white text-xl" :icon="['fal', 'plus']">
                          </font-awesome-icon>
                      </div>
                      <div @click.stop.prevent="addMember" class="text-xs text-additional-text font-bold ml-4">Добавить участника</div>
    </div>

    <invite-modal :team_id="team.id" v-if="inviteModal" :link="inviteLink" :team_name="team.name" @close="inviteModal = false" />
</div>
</template>
<script>
import ConfirmDelete from '@/views/partners/events/order/delete-modal.vue';
import TeamMember from './team-member.vue';
import axios from 'axios';
import { mapState } from 'vuex';
import players from '@/clients/player.js';
import InviteModal from './invite-modal.vue';

export default {
  name: 'team-manage',
  props: ['amICaptain', 'teamId', 'team', 'newTeam'],
  components: { ConfirmDelete, TeamMember, InviteModal },
  data() {
    return {
      teamMembers: [],
      leaveConfirm: true,
      chooseCaptain: false,
      deleteMember: false,
      inviteModal: false,
      inviteLink: '',
    };
  },
  created() {
    this.getMembers();
  },
  computed: {
    ...mapState({
      cur_user: state => state.auth.user,
    }),
  },
  methods: {
    getMembers() {
      if (this.teamId) {
        const teamMembers = [];
        axios.get(`${process.env.VUE_APP_MP_PLAYER_BACKEND}/teams/${this.teamId}/players`).then((resp) => {
          this.teamMembers = resp.data;
          for (let index = 0; index < this.teamMembers.length; index++) {
            this.teamMembers[index].open = false;
          }
        });
      }
    },
    capChange() {
      this.getMembers();
      this.$emit('capChange');
    },

    addMember() {
      players.post(`teams/${this.teamId}/invitations`).then(({ data }) => {
        this.inviteLink = data.link.toString();
        this.inviteModal = true;
        console.log('ajdhfjkahkdf ad f');
      });
    },
  },
  mounted() {
  },
};
</script>
<style  scoped>


</style>
